import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
import Animated, { cancelAnimation, Easing, runOnJS, useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { StyleSheet, View } from "react-native";
import { PressableWrap } from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import {  CloseIcon, ScrollView } from "native-base";
import { LeftSideButton } from "../Buttons/LeftSideButton";
import { GestureDetector, Gesture } from "react-native-gesture-handler";
import type { hanldeSlideOutMenu, option } from "../../Components/interfaces";
import BackDrop, { handleBackDrop } from "../../../Universal/searchBars/Components/BackDrop";
import { ArrowLeft } from "lucide-react-native";

export interface SlideOutMenuProps {
    options: option[];
    setServiceMobile?: (x: null | option[]) => any
}

const SlideOutMenu: React.FC<SlideOutMenuProps> = React.forwardRef<hanldeSlideOutMenu, SlideOutMenuProps>(({ options, setServiceMobile }, ref) => {
    const { currentHeight, currentWidth, scaleAll, isWeb, setLeftSlideOut } = useAppContext();
    
    // Adjust menu width based on screen size
    const menuWidth = currentWidth > 800 ? currentWidth * 0.35 : currentWidth * 0.5;
    
    const translateX = useSharedValue(-menuWidth);
    const opacity = useSharedValue(0);
    const [doAnimation, setDoAnimation] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [closeColor, setCloseColor] = useState("black");

    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: translateX.value }],
    }));

    const animatedStyleOpacity = useAnimatedStyle(() => ({
        opacity: opacity.value,
    }));

    useEffect(() => {
        setDoAnimation(false);
    }, [currentWidth]);

    useImperativeHandle(ref, () => ({
        setDoAnimation,
        getEnabled: () => doAnimation,
        close
    }));

    

    const duration = 350
    useEffect(() => {
        setLeftSlideOut(doAnimation);
        if (doAnimation) {
            setEnabled(true);
            setTimeout(() => refBackDrop.current?.setStart(true), 100); // ✅ start backdrop fade in
            translateX.value = withTiming(0, { duration, easing: Easing.inOut(Easing.ease) });
            opacity.value = withTiming(1, { duration, easing: Easing.inOut(Easing.ease) });
        } else {
            refBackDrop.current?.setStart(false); // ✅ start backdrop fade out
            if (!isWeb) {
                cancelAnimation(translateX);
                cancelAnimation(opacity);
            }
            translateX.value = withTiming(-menuWidth, { duration, easing: Easing.inOut(Easing.ease) }, () => {
                runOnJS(setEnabled)(false);
            });
            opacity.value = withTiming(0, { duration, easing: Easing.inOut(Easing.ease) });
        }
    }, [doAnimation]);

    const panGesture = Gesture.Pan()
        .onUpdate((event) => {
            if (event.translationX < 0) {
                translateX.value = event.translationX;
            }
        })
        .onEnd((event) => {
            if (event.translationX < -50) {
                setDoAnimation(false);
            } else {
                translateX.value = withTiming(0, { duration: duration, easing: Easing.out(Easing.ease) });
            }
        });
    const refBackDrop = useRef<handleBackDrop>(null)

    const close = () => {
        setDoAnimation(false)
        setServiceMobile?.(null);
    }

    const [back, setBack] = useState(false)

    const options_local = React.useMemo(() => {
        // console.log('options', options)
        if(options.find(opt => opt.text == 'back')){
            setBack(true)
            return options.filter(opt => opt.text !== 'back')
        }
        setBack(false)
        return options
    }, [options])

    // useEffect(() => {
    //     console.log('options_local', options_local)
    // },[ options_local])
    return (
        enabled && (
                <>
                <BackDrop ref={refBackDrop} onPress={close}  />
                <View style={[StyleSheet.absoluteFill, { zIndex: 1000000 }]}>
                  
                    <GestureDetector gesture={panGesture}>
                        
                        <Animated.View
                            style={[{
                                backgroundColor: "#F9F9F9",
                                width: menuWidth,
                                height: currentHeight,
                                paddingHorizontal: 10,
                            }, animatedStyle]}
                        >
                            <View>
                                {/* Close Button */}
                                <PressableWrap
                                    onPress={
                                        back ? () => {setServiceMobile?.(null)} :
                                        close}
                                    style={{ alignSelf: "flex-end" }}
                                    setColor={setCloseColor}
                                >
                                    <View style={{ marginVertical: 30, marginRight: 20 * scaleAll }}>
                                        {back ? <ArrowLeft/> : <CloseIcon color={closeColor} />}
                                    </View>
                                </PressableWrap>

                                {/* Options List */}
                                <ScrollView style={{ height: currentHeight - 90 }} showsVerticalScrollIndicator={false}>
                                    {(options_local ?? options).map((option, index) => (
                                        <LeftSideButton key={index} text={option.text} onPress={() => {
                                            
                                            option.onPress(
                                                // {
                                                //     // close: close()
                                                // }
                                            )
                                            
                                        }} />
                                    ))}
                                </ScrollView>
                            </View>
                        </Animated.View>
                    </GestureDetector>
                </View>
                </>
        )
    );
});

export default React.memo(SlideOutMenu);
